import { FC, useState } from 'react';
import styled from './index.module.scss';
import FormStep from './FormStep';
import TradeInForm from './Form';
import Coupon from './Coupon';
import { useLang } from '@/i18n';

interface IProps {
    type?: string;
}

const TradeIn: FC<IProps> = ({}) => {
    const [step, setStep] = useState(1);
    const [code, setCode] = useState('');
    const { t } = useLang('membersday.return.tradein');

    return (
        <div className={styled.TradeIn} id="nav_title_1">
            <h6 className="title">{t('title')}</h6>
            <p className="subtitle">{t('subtitle')}</p>
            <div className="form_box">
                <div className="box-inner">
                    <p className="form_title">{t('form_title')}</p>
                    <p className="form_subtitle">{t('form_subtitle')}</p>
                    <FormStep total={3} step={step} />
                    {step !== 3 && <TradeInForm step={step} handleNext={setStep} handleGetCode={setCode} title={t('title')} />}
                    {step === 3 && <Coupon code={code} />}
                </div>
            </div>
        </div>
    );
};

export default TradeIn;
